import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { AnyObject } from 'yup/lib/types'
import { AMOUNT_VALIDATION_PATTERN } from 'utils/yupSchemas/createNameSchema'
import { createPaymentReferenceSchema } from 'utils/yupSchemas/createReferenceSchema'

export type FiatSendFormData = {
  // Basic send details
  amount: string
  currencyCode: string
  beneficiaryReference: string
  fee?: string
  paymentReference: string
  sourceWalletLsid: string
  transferDestination: string
  // Auth
  callbackUrl?: string
  challengeCode?: string
  twoFactorCode?: string
}

export type FiatSendFormKeys = keyof FiatSendFormData

type AmmountValdiationProps = {
  value: string
  ctx: yup.TestContext<AnyObject>
  t: TFunction<'translation', undefined>
}

export const validateAmount = ({ value, ctx, t }: AmmountValdiationProps) => {
  if (!value) {
    return ctx.createError({
      message: t('fieldIsARequiredField', {
        field: t('amount'),
        interpolation: { escapeValue: false },
      }),
    })
  }

  if (!AMOUNT_VALIDATION_PATTERN.test(value)) {
    return ctx.createError({
      message: t('formFields.errors.invalidAmount'),
    })
  }

  return true
}

export const fiatSendFormSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object<Record<FiatSendFormKeys, yup.AnySchema>>({
    // Basic send details
    amount: yup
      .string()
      .required()
      .test((value, ctx) => validateAmount({ value, ctx, t })),
    fee: yup.string().notRequired(),
    beneficiaryReference: yup.string().required(),
    currencyCode: yup.string().required(),
    paymentReference: createPaymentReferenceSchema(t('formFields.paymentReference'), t, true),
    sourceWalletLsid: yup.string().required(),
    transferDestination: yup.string().required(),
    // Auth
    twoFactorCode: yup.string().notRequired(),
    challengeCode: yup.string().notRequired(),
    callbackUrl: yup.string().notRequired(),
  })
}
